/**
 * Tudunk canvas-t használni.
 * @see https://stackoverflow.com/questions/2745432/best-way-to-detect-that-html5-canvas-is-not-supported
 */
export default function isCanvasSupported (): boolean {
  return Boolean(window.CanvasRenderingContext2D)
}
